// Translation: Error > Landing > Message (English)
export default Object.freeze({
	fallback: {
		title: 'Page not found'
	}
})
